module.exports = __webpack_public_path__ + "static/media/disney-channel.bbc68b7c.png";